// Match backend NotificationEntityType enum exactly
export const NotificationEntityType = {
  ONLINE_ORDER: 'ONLINE_ORDER',
  TABLE_RESERVATION: 'TABLE_RESERVATION',
  NAILS_APPOINTMENT: 'NAILS_APPOINTMENT',
} as const;

export type NotificationEntityType =
  (typeof NotificationEntityType)[keyof typeof NotificationEntityType];

// Payload structure sent by backend to Firebase
export interface NotificationPayload {
  type: NotificationEntityType;
  entityId: string;
}

// Route mapping for each notification type (matches actual panel routes)
export const NotificationRoutes: Record<
  NotificationEntityType,
  (entityId: string) => string
> = {
  // /online-order/dashboard/:onlineOrderID
  [NotificationEntityType.ONLINE_ORDER]: (id) => `/online-order/dashboard/${id}`,
  // /table-reservation/list/:id
  [NotificationEntityType.TABLE_RESERVATION]: (id) => `/table-reservation/list/${id}`,
  // /appointment/list/:appointmentId
  [NotificationEntityType.NAILS_APPOINTMENT]: (id) => `/appointment/list/${id}`,
};
